import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const deleteContainerApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}container`,
        method: "delete",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default deleteContainerApi